// src/icons/UmaBridgeLoading.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function UmaBridgeLoading({
  strokeWidth = "1.5",
  strokeLinecap = "round"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: "11",
            cy: "11",
            r: "9",
            stroke: "#EBEEF2",
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19.9999 11C19.9999 9.57971 19.6638 8.17958 19.019 6.91409C18.3742 5.6486 17.439 4.55368 16.29 3.71885C15.1409 2.88402 13.8106 2.33299 12.4078 2.11081C11.005 1.88862 9.56953 2.0016 8.21875 2.44049",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        )
      ]
    }
  );
}

export {
  UmaBridgeLoading
};
